import {makePostOurDoctorMessage} from 'main/factories/usecases/private/remote-home/post-our-doctor-message';
import {EntryPointCodeEnum} from 'presentation/pages/private/booking/constants';

export const postOurDoctorMessage = async () => {
	const response = await makePostOurDoctorMessage().post({
		entryPointCode: Number(EntryPointCodeEnum.V1),
	});
	return response;
};
